<template>

    <div class="layout__container">

        <div class="layout__padding-20px">
            <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                <div class="layout__padding-clear layout__width-50 layout__padding-20-0 layout__border__bottom-light-teal-1px">
                    <h3 class="text__colour-teal">Create a user</h3>
                    <p>New users will be created on the system, but will not be recognised as active until the user logs
                        into the system for the first time</p>
                    <p>Initial password for newly created users: <span class="text__colour-red">MyRav2020</span></p>
                </div>
            </div>

            <div class="layout__width-100 layout__overflow-hidden layout__border__all-1px-grey">
                <div class="layout__padding-20px">
                    <el-form :model="create_user" ref="create_user" :rules="rules"
                             class="layout__width-100 layout__position-left">
                        <div class="layout__padding-clear">

                        </div>
                        <el-form-item prop="email_address" class="layout__width-100">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">Email
                                Address<span class="text__colour-red">*</span></div>
                            <h5 class="layout__padding-clear layout__padding-5-0">Email address of the new user</h5>
                            <el-input v-model="create_user.email_address" class="layout__position-left">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="customer_ref" class="layout__width-100">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">Customer
                                Refs<span class="text__colour-red">*</span></div>
                            <h5 class="layout__padding-clear layout__padding-5-0">Customer Branch Code</h5>
                            <el-input v-model="create_user.customer_ref" class="layout__position-left">
                            </el-input>
                            <h5 class="layout__padding-clear layout__padding-5-0">Comma separated list is the required input format for Multi-branch users: XXX1,XXX2</h5>
                        </el-form-item>
                        <el-form-item prop="first_name" class="layout__width-100">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">First name<span
                                    class="text__colour-red">*</span></div>
                            <h5 class="layout__padding-clear layout__padding-5-0">User's first name</h5>
                            <el-input v-model="create_user.first_name" class="layout__position-left">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="last_name" class="layout__width-100">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">Last
                                name<span class="text__colour-red">*</span></div>
                            <h5 class="layout__padding-clear layout__padding-5-0">User's last name</h5>
                            <el-input v-model="create_user.last_name" class="layout__position-left">
                            </el-input>
                        </el-form-item>

                        <el-button class="button-red button__base layout__width-200px layout__margin-15" v-on:click="addStagedUser('create_user')">
                            Create User
                        </el-button>

                        <el-button
                                class="button-teal button__base layout__width-200px layout__margin-15 layout__position-right"
                                v-on:click="">Cancel
                        </el-button>

                    </el-form>

                    <div id="success">
                        <p class="component__message-base component__message-success">User successfully created</p>
                    </div>
                    <div id="error">
                        <p class="component__message-base component__message-fail">There was an error creating the user<br> Please contact the Development team with the details entered above </p>
                    </div>
                    <div id="error_branch">
                        <p class="component__message-base component__message-fail">Invalid branch code used to setup the user account <br> Please amend the branch code and try again.</p>
                    </div>
                </div>
            </div>


        </div>


    </div>

</template>

<script>
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {Loading} from 'element-ui';

    export default {
        name: "adminOrders",
        components: {},
        mixins: [axios, dataFormatter, backing, csvDownloadHelper],
        props: {},
        data() {
            const focReason = (rule, value, callback) => {
                if (this.bespokeOrderItem.priceMethod === 'FOC' && this.bespokeOrderItem.focReason === '') {
                    callback(new Error('enter a foc reason required'));
                } else if (this.bespokeOrderItem.priceMethod !== 'FOC' && this.bespokeOrderItem.focReason !== '') {
                    callback(new Error('please remove foc reason - price method not \'FOC\''));
                } else {
                    callback();
                }
            };
            return {
                create_user: {
                    email_address: '',
                    password: '',
                    customer_ref: '',
                    first_name: '',
                    last_name: ''
                },
                rules: {
                    email_address: [
                        {
                            required: true,
                            message: 'Email address required',
                            trigger: 'blur'
                        },
                    ],
                    customer_ref: [
                        {
                            required: true,
                            message: 'Customer branch code required',
                            trigger: 'blur'
                        },
                    ],
                    password: [
                        {
                            required: true,
                            message: 'Initial Password required',
                            trigger: 'blur'
                        },
                    ],
                    first_name: [
                        {
                            required: true,
                            message: 'User first name required',
                            trigger: 'blur'
                        },
                    ],
                    last_name: [
                        {
                            required: true,
                            message: 'User last name required',
                            trigger: 'blur'
                        },
                    ],
                    focReason: [{
                        validator: focReason
                    }]
                }
            }
        },
        created() {
          this.isUserAuthorised();
        },
        mounted() {
            document.getElementById('error').style.display = 'none';
            document.getElementById('success').style.display = 'none';
            document.getElementById('error_branch').style.display = 'none';

        },
        beforeDestroy() {
        },
        methods: {
            addStagedUser(create_user) {
                this.$refs[create_user].validate((valid) => {
                    if (valid) {

                        let loadingInstance = Loading.service({
                            fullscreen: true
                        });

                        const url = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/Maintenance/AddStagedUser/?emailAddress=`
                        + this.create_user.email_address +
                            '&plainPassword=' + '' +
                                '&customerRefs=' + this.create_user.customer_ref +
                                '&firstName=' + this.create_user.first_name +
                                '&lastName=' + this.create_user.last_name


                        console.log(url)

                        Axios.post(url, {}, this.returnHeaderInternal())
                            .then(response => {
                                console.log(response)

                                this.create_user.email_address = '';
                                this.create_user.password = '';
                                this.create_user.customer_ref = '';
                                this.create_user.first_name = '';
                                this.create_user.last_name = '';

                                document.getElementById('success').style.display = 'block';


                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });

                            })
                            .catch(error => {
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });

                                if (error.response.data.error.details === "Invalid customer ref(s)") {
                                    document.getElementById('error_branch').style.display = 'block';
                                } else {
                                    document.getElementById('error').style.display = 'block';
                                }
                            });

                    } else {
                        return false;
                    }
                })
            }

        }
    };
</script>